import React, { useState } from 'react'
import { useNavigate, Link } from 'react-router-dom'
import '../styles/Register.css'

const BASE_URL = 'https://api.admin.yourhood.ge'

function Register() {
  const [form, setForm] = useState({
    name: '',
    lastname: '',
    phone: '',
    password: '',
    confirmPassword: ''
  })
  const [error, setError] = useState('')
  const [success, setSuccess] = useState('')
  const [isLoading, setIsLoading] = useState(false)
  const navigate = useNavigate()

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value })
  }

  const handleRegister = async (e) => {
    e.preventDefault()
    setError('')
    setSuccess('')

    const { name, lastname, phone, password, confirmPassword } = form

    if (!name.trim() || !lastname.trim() || !phone.trim() || !password.trim() || !confirmPassword.trim()) {
      setError('გთხოვთ შეავსოთ ყველა ველი')
      return
    }

    if (password !== confirmPassword) {
      setError('პაროლები არ ემთხვევა')
      return
    }

    setIsLoading(true)
    try {
      const res = await fetch(`${BASE_URL}/api/Auth/register`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Language': 'ka'
        },
        body: JSON.stringify({ name, lastname, phone, password, confirmPassword })
      })

      const data = await res.json()

      if (res.ok && data.key) {
        setSuccess('რეგისტრაცია წარმატებით დასრულდა!')
        setTimeout(() => navigate('/'), 2000)
      } else {
        setError('რეგისტრაცია ვერ მოხერხდა. სცადეთ თავიდან.')
      }
    } catch (err) {
      setError('კავშირის შეცდომა. სცადეთ თავიდან.')
    } finally {
      setIsLoading(false)
    }
  }

  return (
    <div className="reg-container">
      <div className="reg-card">
        <div className="reg-header">
          <span className="reg-brand">YourHood</span>
          <h1 className="reg-title">რეგისტრაცია</h1>
          <p className="reg-subtitle">შექმენით თქვენი ანგარიში</p>
        </div>

        <form onSubmit={handleRegister} className="reg-form">
          <div className="reg-form-row">
            <div className="reg-form-group">
              <label className="reg-label">სახელი</label>
              <input
                type="text"
                name="name"
                className="reg-input"
                placeholder="სახელი"
                value={form.name}
                onChange={handleChange}
                disabled={isLoading}
                autoComplete="given-name"
              />
            </div>
            <div className="reg-form-group">
              <label className="reg-label">გვარი</label>
              <input
                type="text"
                name="lastname"
                className="reg-input"
                placeholder="გვარი"
                value={form.lastname}
                onChange={handleChange}
                disabled={isLoading}
                autoComplete="family-name"
              />
            </div>
          </div>

          <div className="reg-form-group">
            <label className="reg-label">ტელეფონის ნომერი</label>
            <input
              type="tel"
              name="phone"
              className="reg-input"
              placeholder="5XXXXXXXX"
              value={form.phone}
              onChange={handleChange}
              disabled={isLoading}
              autoComplete="tel"
            />
          </div>

          <div className="reg-form-group">
            <label className="reg-label">პაროლი</label>
            <input
              type="password"
              name="password"
              className="reg-input"
              placeholder="••••••••"
              value={form.password}
              onChange={handleChange}
              disabled={isLoading}
              autoComplete="new-password"
            />
          </div>

          <div className="reg-form-group">
            <label className="reg-label">გაიმეორეთ პაროლი</label>
            <input
              type="password"
              name="confirmPassword"
              className="reg-input"
              placeholder="••••••••"
              value={form.confirmPassword}
              onChange={handleChange}
              disabled={isLoading}
              autoComplete="new-password"
            />
          </div>

          {error && <div className="reg-error">{error}</div>}
          {success && <div className="reg-success">{success}</div>}

          <button type="submit" className="reg-button" disabled={isLoading}>
            {isLoading ? 'რეგისტრაცია...' : 'რეგისტრაცია'}
          </button>
        </form>

        <div className="reg-links">
          <Link to="/" className="reg-link">უკვე გაქვთ ანგარიში? შესვლა</Link>
        </div>

        <div className="reg-footer">
          <span className="reg-footer-text">© 2026 YourHood · დაცული კავშირი</span>
        </div>
      </div>
    </div>
  )
}

export default Register